export const formatText = (text: string) => {
  const formattedText = text?.replace(/\n/g, '<br>');

  return formattedText;
};
